import { Icon } from "@circle-react/components/shared/Icon";
import { SpaceHeaderTitleText } from "@circle-react/components/Spaces/Header/SpaceHeaderTitle/SpaceHeaderTitleText";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useNavigate } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";
import { StandardLayoutHeaderWithPortal } from "@/react/components/Layout/StandardLayoutV2/StandardLayoutHeader/StandardLayoutHeaderWithPortal";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";

export interface BreadcrumbProps {
  backLink?: string;
  backLinkText?: string;
  className?: string;
  customRightContent?: React.ReactNode;
  hasBorder?: boolean;
  hidden?: boolean;
}

export const Breadcrumb = ({
  hidden = false,
  backLink = "",
  backLinkText = t("back"),
  className,
  customRightContent,
  hasBorder,
}: BreadcrumbProps) => {
  const { isViewOnlyMasquerading } = usePunditUserContext();
  const navigate = useNavigate();

  const onClickBackHandler = () => {
    void navigate({ to: backLink });
  };

  if (hidden || !backLink) {
    return null;
  }

  return (
    <StandardLayoutHeaderWithPortal
      className={className}
      hasBorder={hasBorder}
      leftContent={
        <SpaceHeaderTitleText>
          <Button
            type="button"
            variant="text"
            extraLarge
            onClick={onClickBackHandler}
            className={classNames("flex items-center gap-2", {
              // This css rule will override the pointer-events-none class
              // that is cascaded down from the StandardLayoutHeader component
              // We want to allow pointer events on the back link when VOM masquerading
              "!pointer-events-auto": isViewOnlyMasquerading,
            })}
          >
            <Icon type="20-arrow-left" size={20} />
            {backLinkText}
          </Button>
        </SpaceHeaderTitleText>
      }
      rightContent={customRightContent || null}
    />
  );
};
